import { MfaMethod } from "./types";

/**
 * Allowed values for the Portal ID picker. Both the display label and the
 * stored value are the raw identifier strings.
 */
export const PORTAL_ID_OPTIONS = [
  "oncoemr",
  "cmm",
  "availity_health_first_nar",
  "availity_bcbs_nar",
  "cigna",
  "emblem",
  "fidelis",
  "oscar",
  "priority_health",
  "covermymeds",
  "healthfirst_submission",
].map((id) => ({ label: id, value: id }));

/**
 * Boolean-as-string options shared by every Yes/No radio in this modal
 * (`mfa_present`, `is_active`).
 */
export const YES_NO_OPTIONS = [
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];

/**
 * Branch options for the inner Multi-Factor Authentication configuration
 * radio. Values map 1:1 to the `MfaMethod` type.
 */
export const MFA_METHOD_OPTIONS: { label: string; value: MfaMethod }[] = [
  { label: "Add Secret Key", value: "secret_key" },
  { label: "Add Email Of OTP Inbox", value: "otp_email" },
];

/**
 * `dialogId` used by the global `openModal` / `closeModal` registry to
 * target this modal. Centralized so the orchestrator and the lifecycle
 * hook can't drift.
 */
export const MODAL_DIALOG_ID = "credential-details-modal";
